import React from 'react';
import Carousel from 'nuka-carousel';
import Button from '../../../components/Button/Button';
import { ComponentTheme } from '../../../definitions/components';
import { isEmptyHTML } from '../../../services/utils';

export const BannerSlider = (props) => {
  return (
    <div className="banner-slider">
      <Carousel {...props}>
        {...props.children}
      </Carousel>
    </div>
  );
};

export const BannerSlide = ({
  title, bannerImage, bannerVideo, description, buttonUrl
}) => {
  return (
    <div
      key={`banner--home-${title}`}
      className="banner"
      style={bannerImage}>

      {bannerVideo && <Video banner={bannerVideo} />}

      <BannerSlideContent
        title={title}
        description={description}
        buttonUrl={buttonUrl} />
    </div>
  );
};

const Video = ({banner}) => {
  return (
    <video
      className="banner-video"
      poster="https://d18md549cxuah8.cloudfront.net/images/banner/1492716678470-0.jpeg/1400/500"
      autoPlay
      loop
      muted>
      <source src={banner} />
    </video>
  );
};

const BannerSlideContent = ({ title, description, buttonUrl }) => {
  return (
    <div className="banner-content">
      {title && <p className="title">{title}</p>}

      {!isEmptyHTML(description) &&
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: description }}
        />}

      {buttonUrl &&
        <Button
          link={buttonUrl}
          theme={ComponentTheme.LIGHT_TRANSPARENT}
        />}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Home/components/BannerSlider.tsx